import React from "react";
import { useNavigate } from "react-router-dom";
import tw from "tailwind-styled-components";
import { FaWarehouse, FaUsers, FaUniversity, FaExclamationCircle, FaUserTie, FaMoneyBillWave, FaCreditCard, FaBriefcase, FaUser, FaFileContract } from "react-icons/fa";
import { TbCalendarDue } from "react-icons/tb";
import { FaMoneyBill, FaMoneyBillTrendUp } from "react-icons/fa6";

const actions = [
    { icon: <FaWarehouse size={24} className="text-gray-500" />, label: "Manage Properties", bg: "bg-purple-100", path: "/landlord/property-list" },
    { icon: <FaUsers size={24} className="text-gray-500" />, label: "Manage Primary Tenants", bg: "bg-green-100", path: "/landlord/client" },
    { icon: <FaFileContract size={24} className="text-gray-500" />, label: "Agreement", bg: "bg-red-100", path: "/landlord/agreement" },
    { icon: <TbCalendarDue size={24} className="text-gray-500" />, label: "Dues", bg: "bg-blue-100", path: "/landlord/dues" },
    { icon: <FaMoneyBill size={24} className="text-gray-500" />, label: "Collection", bg: "bg-blue-100", path: "/landlord/collections" },

];

const QuickAction = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Title>Quick Actions</Title>
            <Grid>
                {actions.map((action, index) => (
                    <ActionCard key={index} className={action.bg} onClick={() => navigate(action.path)}>
                        <IconWrapper>{action.icon}</IconWrapper>
                        <Label>{action.label}</Label>
                    </ActionCard>
                ))}
            </Grid>
        </Container>
    );
};

const Container = tw.div`shadow-md rounded-lg gap-4 p-4 bg-white`;
const Title = tw.h2`text-lg font-semibold mb-4 text-gray-800`;
const Grid = tw.div`grid grid-cols-2 gap-3`;
const ActionCard = tw.div`flex flex-col items-center px-4 py-4 rounded-lg shadow-sm cursor-pointer transition hover:shadow-md`;
const IconWrapper = tw.div`w-12 h-10 flex items-center justify-center rounded-lg`;
const Label = tw.p`text-sm text-gray-600 font-normal text-center`;

export default QuickAction;
